export const getIframeUrl = (url) => {
  return location.origin + url
}
